export default "__VITE_ASSET__BGnneTTu__"